import { getAssetURL } from '../api';

export const getAssetDownloadUrl = (url) => {
    const urlEncoded = getAssetURL(encodeURIComponent(url))

    return urlEncoded.replaceAll('%2F', '/')
}